import React, { useState, useEffect } from 'react';
import './MerchantDetailsCard.scss';

export const MerchantDetailsCard = ({ title, children, startOpen }) => {
    const [cardOpen, setCardOpen] = useState(startOpen);
    useEffect(() => {
        setCardOpen(startOpen);
    }, [startOpen]);

    return (
        <>
            <div className="merchant-details-card">
                <div className="merchant-details-card-header">
                    <h3 className="merchant-details-card-title">{title}</h3>
                    <button className="merchant-details-arrow-button" onClick={() => setCardOpen(!cardOpen)}>
                        <div className="material-icons">
                            {cardOpen ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}
                        </div>
                    </button>
                </div>

                {cardOpen && (
                    <div className="merchant-details-card-content">
                        {children}
                    </div>
                )}
            </div>
        </>
    );
};

export default MerchantDetailsCard;